var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleFilesPurpleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13209_5944)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#6FA0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8324 14.794L24.988 23.4608C24.6154 24.7268 23.6795 25.6762 22.5278 26.1305C22.832 25.4245 23.0012 24.6477 23.0012 23.8317V15.4975C23.0012 12.2802 20.3835 9.66297 17.1674 9.66297H15.7798C16.804 8.31353 18.6016 7.6559 20.3176 8.18017L25.0563 9.63547C27.2265 10.3023 28.4716 12.6161 27.8324 14.794ZM21.3344 15.4975V23.8325C21.3344 26.1305 19.465 28 17.1674 28H12.167C9.86931 28 8 26.1305 8 23.8325V15.4975C8 13.1995 9.86931 11.33 12.167 11.33H17.1674C19.465 11.33 21.3344 13.1995 21.3344 15.4975Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13209_5944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleFilesPurpleBg);
export default __webpack_public_path__ + "static/media/double-files-purple-bg.ef5ce2197d21e79747d7d687ad4a38df.svg";
export { ForwardRef as ReactComponent };